import React from 'react';
import type { IconProps } from './types';

export const Vector = ({ onClick }: IconProps) => (
  <div role="none" className="icon icon-vector" onClick={onClick}>
    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.5 1L7 7.5L13.5 0.999999" stroke="#FC4C02" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </div>
);
